/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuTypeaheadContainer_viewer = {
    readonly isSearchWithinFilterEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeahead_viewer">;
    readonly " $refType": "SbSharedRefineMenuTypeaheadContainer_viewer";
};
export type SbSharedRefineMenuTypeaheadContainer_viewer$data = SbSharedRefineMenuTypeaheadContainer_viewer;
export type SbSharedRefineMenuTypeaheadContainer_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuTypeaheadContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSearchWithinFilterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REFINE_MENU_SEARCH"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeahead_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'cdc32f46cd0d50c9dfad531b76e5bd14';
export default node;
